module.exports = __webpack_public_path__ + "img/ScattleTimelapse.885ea58a.jpg";